import createReducer from "../createReducer";
import { zapierHandlers } from "./handlers";
import { IZapierState } from "./types";

export const zapierAuthUrl: IZapierState = {
    isLoading: false,
    error: null,
    authUrl: null,
    formId: null,
};

export default createReducer(zapierAuthUrl, zapierHandlers);
